module.exports = require('../dist/mappings/index');
